import { doc, getDoc, onSnapshot, setDoc } from "firebase/firestore"
import { useEffect, useState } from "react"
import { db } from "../config/firebase"
import { StartSession } from "../functions/metter"

export default function useStatus(setLoading) {

    const [session, setSession] = useState(null)

    useEffect(() => {

        return onSnapshot(doc(db, 'sessions/xVvJ0cgMw4Y1xItNteiSF15fn5O2'), {
            next: el => setSession(el.data()),
            error: console.log
        })

    }, [])

    async function closeAllOrders(orders) {
        try {

            setLoading(true)
           
            for await (const order of orders) {
                await setDoc(doc(db, `orders/${order.id}`), {
                    status: "closed",
                }, { merge: true }) 
            }

            setLoading(false)
            
       } catch(err) {
            setLoading(false)
       }
    }

    async function ToggleOnline() {
 
        setLoading(true)

        const store = (await (getDoc(doc(db, `backup/xVvJ0cgMw4Y1xItNteiSF15fn5O2`)))).data()

        if(!store.storeOnline) {

            localStorage.setItem("ordernumber", "1")
            StartSession() 
            
            await setDoc(doc(db, `backup/xVvJ0cgMw4Y1xItNteiSF15fn5O2`), { 
                storeOnline: true,
            }, { merge: true })

        } else {

            await setDoc(doc(db, `backup/xVvJ0cgMw4Y1xItNteiSF15fn5O2`), { 
                storeOnline: false,
            }, { merge: true })
            
        } 

        setLoading(false)
    }

    return { session, closeAllOrders, ToggleOnline }
}